import axios from 'axios';

import router from '@/router';
import store from '@/store/store';

// response interceptor to detect any logged out sessions
// and logout the user if response has any 401
axios.interceptors.response.use(res => res, err => {
    if (err.response.status === 401) {
        store.dispatch("logoutUser").finally(() => router.replace("/"));
    } else return Promise.reject(err.response);
});

export const $http = axios;

export const Constants = {
    BaseURL: process.env.VUE_APP_BASEURL,
    FrontendURL: process.env.VUE_APP_FRONTEND_URL,
    formatFromDate: (item) => {
        // convert from UTC(1984-09-04T02:00:00+02:00) date to dd-mm-yyyy format
        if (item) {
            let date = `${item}`.substring(0, 10);
            let [y, m, d] = date.split('-');
            if (m === '01' && d === '01' && y === '0001') {
                return false;
            }
            return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
        }
        return false;
    },
    getPayloadByAction: (data, url) => {
        let payload = data.payload;
        switch (data.action) {
            case 'editBenefit':
            case 'editProviderBenefits':
                payload = { id: data.id, data: { ...data.payload, url: url } };
                break;
            case 'addBenefit':
            case 'addProviderBenefits':
                payload.url = url;
                break;
            case 'employeeSave':
                payload.data.profile_image_url = url;
                break;
            default:
                payload.logo_url = url; //edit company & provider
        }
        return payload;
    }
};
